<template>
  <router-link :to="{ name: cardContent.path }">
    <div class="card-wrapper">
      <div class="content">
        <div class="icon">
          <Vue3Lottie
            :animationLink="animationLinks[randomAnimation]"
            :loop="false"
          />
        </div>
        <h3 class="dishName">{{ cardContent.name }}</h3>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  props: ["cardContent"],
  data() {
    return {
      //Add animation links in the below array from lotteflies and the icons will be randomly loaded
      animationLinks: [
        "https://lottie.host/ede63bd6-fdb9-4c3f-ac82-a07ca809053d/snzAcGHxgj.json",
        // "https://lottie.host/80453ca9-f0ef-4bc0-a988-597b275c8956/kb7Qj0oCT9.json",
        // "https://lottie.host/6d317c94-408d-48f4-b981-5cf9de9649c3/aeeIsewGTT.json",
      ],
    };
  },
  computed: {
    randomAnimation() {
      const random = Math.floor(Math.random() * this.animationLinks.length);
      return random;
    },
  },
};
</script>
<style scoped>
.card-wrapper {
  padding: 1.2rem;
  cursor: pointer;
  border-radius: 20px;

  box-shadow: 0px 10px 100px 22px rgba(0, 0, 0, 0.1);

  display: grid;
  place-items: center;
  background-color: rgba(255, 255, 255, 0.731);
  backdrop-filter: blur(4px);
}
.card-wrapper > h3 {
  text-transform: uppercase;
}
.content {
  /* display: flex;
  align-items: center;
  justify-content: center; */

  display: grid;
  /* grid-template-columns: 1fr 1fr; */
  place-items: center;
}
.icon {
  height: 5rem;
  width: 5rem;

  display: flex;
  align-items: center;
  justify-content: center;
}
.dishName {
  /* justify-self: start; */
  text-align: center;
  margin: 0;
}
</style>
